import React from 'react'
import './FormLoader.css'

const { createContext, useState } = React
const defaultMessage = 'Please wait while the form is loaded...'

export const FormSpinner = ({ message = defaultMessage }) => {
  return (
    <div className="waiting-overlay">
      <div className="justify-content-center">
        <p>
          <b>{message}</b>
        </p>
        <div className="pacterpillar">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  )
}

export const LoaderContext = createContext({
  message: defaultMessage,
  counter: 0,
  up: () => {
    // do nothing
  },
  down: () => {
    // do nothing
  },
})

export const LoaderProvider = ({ children }) => {
  const up = () => {
    update((prev) => ({
      ...prev,
      counter: prev.counter + 1,
    }))
  }
  const down = () => {
    update((prev) => ({
      ...prev,
      counter: prev.counter - 1,
    }))
  }

  const [state, update] = useState({
    message: defaultMessage,
    counter: 0,
    up,
    down,
  })
  return (
    <LoaderContext.Provider value={state}>
      {state.counter > 0 ? <FormSpinner message={state.message} /> : null}
      {children}
    </LoaderContext.Provider>
  )
}

export default LoaderContext
